import SignIn from '@/app/sign-in/main';
import Dashboard from '@/app/dashboard/main';

import Agenda from '@/app/agenda/agenda';
import Inbox from '@/app/inbox/inbox';
import Gallery from '@/app/gallery/gallery';
import Album from '@/app/gallery/album/album';
import LeavingMonitor from '@/app/leaving-monitor/leaving-monitor';
import Medicine from '@/app/medicine/medicine';
import NewMessage from '@/app/inbox/new-message/new-message';
import ReplyMessage from '@/app/inbox/reply-message/reply-message';
import SendMessage from '@/app/inbox/send-message/send-message';
import MealMenu from '@/app/meal-menu/main';
import MealMenuClone from '@/app/meal-menu/clone/main';
import MealMenuMonthly from '@/app/meal-menu/monthly/main';

import LessonPlanning from '@/app/lesson-planning/main';
import LessonPlanningReport from '@/app/lesson-planning/report/main';
import Evaluation from '@/app/evaluation/main';

import Simulator from '@/app/simulator/simulator/simulator';
import SimulatorValues from '@/app/simulator/simulator/values/values';

export default [{
	path: '/',
	name: 'SignIn',
	component: SignIn
}, {
	path: '/dashboard',
	name: 'Dashboard',
	component: Dashboard
}, {
	path: '/agenda',
	name: 'Agenda',
	component: Agenda
}, {
	path: '/inbox',
	name: 'Inbox',
	component: Inbox
}, {
	path: '/inbox/send-message',
	name: 'SendMessage',
	component: SendMessage
}, {
	path: '/inbox/new-message',
	name: 'NewMessage',
	component: NewMessage
}, {
	path: '/inbox/reply-message/:id',
	name: 'ReplyMessage',
	component: ReplyMessage
}, {
	path: '/get-at-school',
	name: 'LeavingMonitor',
	component: LeavingMonitor
}, {
	path: '/medicine',
	name: 'Medicine',
	component: Medicine
}, {
	path: '/meal-menu',
	name: 'MealMenu',
	component: MealMenu
}, {
	path: '/gallery/album',
	name: 'Album',
	component: Album
}, {
	path: '/gallery/album/:id',
	name: 'AlbumID',
	component: Album
}, {
	path: '/meal-menu/clone',
	name: 'MealMenuClone',
	component: MealMenuClone
}, {
	path: '/meal-menu/monthly',
	name: 'MealMenuMonthly',
	component: MealMenuMonthly
}, {
	path: '/gallery',
	name: 'Gallery',
	component: Gallery
}, {
	path: '/lesson-planning',
	name: 'LessonPlanning',
	component: LessonPlanning
}, {
	path: '/lesson-planning/report',
	name: 'LessonPlanningReport',
	component: LessonPlanningReport
}, {
	path: '/evaluation',
	name: 'Evaluation',
	component: Evaluation
}, {
	path: '/simulator',
	name: 'Simulator',
	component: Simulator
}, {
	path: '/simulator/values',
	name: 'SimulatorValues',
	component: SimulatorValues
}];



// WEBPACK FOOTER //
// ./sources/router/routes.js